<template>
    <div class="note">
        <p>{{ data.description }}</p>
    </div>
</template>

<script setup>
defineProps({
    data:Object,
    field:Object,
})
</script>